import { z } from 'zod';

export const subjectOptionList = [
  {
    label: 'Şikayet',
    value: 8,
  },
  {
    label: 'Öneri',
    value: 9,
  },
  {
    label: 'Ekibe Katıl',
    value: 10,
  },
];

export const formValues = {
  name: '',
  surname: '',
  email: '',
  subject: '',
  message: '',
  acikrizaChecked: false,
  aydinlatmaChecked: false,
  contactChecked: false,
};

export const iletisimFormValidationSchema = z.object({
  name: z.string({ required_error: '' }).min(1, { message: 'Adınızı giriniz.' }),
  surname: z.string({ required_error: '' }).min(1, { message: 'Soyadınızı giriniz.' }),
  email: z
    .string({ required_error: '' })
    .min(1, { message: 'E-posta adresiniz.' })
    .email({ message: 'Geçersiz bir email girişi yapıldı.' }),
  subject: z
    .string()
    .nonempty('Konu seçiniz.')
    .transform((e) => Number(e)),
  message: z.string({ required_error: 'Mesajınızı yazınız.' }).min(1, { message: 'Mesajınızı yazınız.' }),
  acikrizaChecked: z.boolean().refine((val) => val === true, 'Lütfen onaylayınız.'),
  aydinlatmaChecked: z.boolean().refine((val) => val === true, 'Lütfen onaylayınız.'),
  contactChecked: z.boolean().optional(),
});
